import pageOverlayOpeningCallback from 'foundation/js/pageOverlayOpeningCallback'
import pageOverlayClosingCallback from 'foundation/js/pageOverlayClosingCallback'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'
import { globalFetch } from "foundation/js/api"
const pageOverlayReturntarget = '.kb-js--page-overlay-return-target'

export default {
    namespaced: true,
    state: {
        article_overlay_open: false,
        page_overlay_open: null,
        page_overlay_content: null,
        page_overlay_content_data: null,
        page_overlay_returntarget: null,
        burger_menu_links: {
            primary: [],
            secondary: []
        },
        article_overlay_data: null,
        sub_navigation_links: {
            generalLink: undefined,
            subLinks: undefined
        },
        dictionary_visible: false,
        page_id: null,
        user: {
            user_id: null,
            user_has_notifications: false,
            show_user: false,
            user_authorized: false,
            user_name: null,
            user_profile_img: null,
            user_has_logged_in_as_frivillig_admin: false,
        },
        is_submitting: false
    },
    mutations: {
        set_dictionary_visible(state, value) {
            state.dictionary_visible = value
        },
        open_page_overlay(state) {
            state.page_overlay_open = true

            pageOverlayOpeningCallback()
        },
        close_page_overlay(state) {
            state.page_overlay_open = false

            pageOverlayClosingCallback()
        },
        reset_page_overlay(state) {
            state.page_overlay_open = null
            state.page_overlay_content = null
            state.page_overlay_returntarget = null

            pageOverlayClosingCallback()
        },
        set_user_id(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_id = payload
            state.user = user
        },
        set_user_has_notifications(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_has_notifications = payload
            state.user = user
        },
        set_show_user(state, payload) {
            const user = Object.assign({}, state.user)
            user.show_user = payload
            state.user = user
        },
        set_user_authorized(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_authorized = payload
            state.user = user
        },
        set_user_name(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_name = payload
            state.user = user
        },
        set_user_profile_img(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_profile_img = payload
            state.user = user
        },
        set_user_has_logged_in_as_frivillig_admin(state, payload) {
            const user = Object.assign({}, state.user)
            user.user_has_logged_in_as_frivillig_admin = payload
            state.user = user
        },
        set_page_overlay_content(state, content) {
            state.page_overlay_content = content
        },
        set_page_overlay_content_data(state, content) {
            state.page_overlay_content_data = {
                ...state.page_overlay_content_data,
                ...content
            }
        },
        set_burger_menu_links(state, linkData) {
            state.burger_menu_links = linkData
        },
        set_page_overlay_returntarget(state, target) {
            state.page_overlay_returntarget = target
        },
        set_article_overlay_data(state, text) {
            state.article_overlay_data = text
        },
        set_sub_navigation_links(state, allLinks) {
            state.sub_navigation_links.generalLink = allLinks.generalLink
            state.sub_navigation_links.subLinks = allLinks.subLinks
        },
        set_article_overlay_open(state, status) {
            state.article_overlay_open = status
        },
        set_page_id(state, pageId) {
            state.page_id = pageId
        },
        set_user_profile_data(state, data) {
            state.user_profile = data
        },
        set_is_submitting(state, isSubmitting) {
            state.is_submitting = isSubmitting
        }
    },
    actions: {
        closePageOverlay(context) {
            if (context.state.page_overlay_returntarget) {
                context.state.page_overlay_returntarget.focus()
                context.state.page_overlay_returntarget.classList.remove(
                    pageOverlayReturntarget.slice(1)
                )
            }
            context.commit('close_page_overlay')
        },
        openPageOverlay(context, config) {
            context.commit('set_page_overlay_content', config.overlayContent)
            context.commit('set_page_overlay_returntarget', config.returnTarget)

            if (config.returnTarget)
                context.state.page_overlay_returntarget.classList.add(
                    pageOverlayReturntarget.slice(1)
                )

            context.commit('open_page_overlay')
        },
        getArticleOverlayContent(context, url) {
            const myHeaders = new Headers()
            myHeaders.append('Content-Type', 'text/article')

            const myInit = {
                headers: myHeaders
            }

            const fetchConfig = new Request(url, myInit)
            return globalFetch(fetchConfig)
                .then((res) => {
                    if (res.ok) return res.text()
                    throw new Error('Search failed')
                })
                .then((text) => {
                    context.commit('set_article_overlay_data', text)
                    return text
                })
                .catch((err) => console.error(err))
        },
        setPageId(context, pageId) {
            if (context.state.page_id) {
                throw new Error('Page id already set')
            }
            context.commit('set_page_id', pageId)
        },
        setUserData(context, userData) {
            if (isObjectNotNullOrEmpty(userData)) {
                userData?.userId ? context.commit('set_user_id', userData.userId) : null
                userData?.firstName && userData?.lastName ? context.commit('set_user_name', `${userData.firstName} ${userData.lastName}`) : 
                                       userData?.firstName  ? context.commit('set_user_name', `${userData.firstName}`) : null
                userData?.userAuthorized ? context.commit('set_user_authorized', userData.userAuthorized) : null
                userData?.showUser ? context.commit('set_show_user', userData.showUser) : null
                userData?.userProfileImg ? context.commit('set_user_profile_img', userData.userProfileImg) : null
                userData?.userHasNotifications ? context.commit('set_user_has_notifications', userData.userHasNotifications) : null
                userData?.userHasLoggedInAsFrivilligAdmin ? context.commit('set_user_has_logged_in_as_frivillig_admin', userData.userHasLoggedInAsFrivilligAdmin) : null
            }
        },
        setUserProfileImage(context, profileImage) {
            context.commit('set_user_profile_img', profileImage)
        },
        fetchUserProfile(context, userProfileId) {
            const url = `${document.location.origin}/${process.env.GET_USERPROFILE.replace('[userProfileId]', userProfileId)}`
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    context.commit('set_user_profile_data', data)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        updateUserProfile(context, config) {
            const url = `${document.location.origin}/${process.env.UPDATE_USERPROFILE.replace('[userProfileId]', config.userProfileId)}`

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const method = process.env.PUTMETHOD
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }

            context.commit('set_is_submitting', true)
            return globalFetch(url, init)
            .then((response) => {
                if (!response.ok) {
                    console.error(response.error)
                    return Promise.reject(response.error)
                }
                return response.json()
            })
            .catch((err) => {
                console.error(err)
                context.commit('set_is_submitting', false)
            })
        },
        deleteUserProfile(context, config) {
            const url = `${document.location.origin}/${process.env.UPDATE_USERPROFILE.replace('[userProfileId]', config.userProfileId)}`

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const method = process.env.DELETEMETHOD
            const init = {
                headers,
                method,
                body: JSON.stringify(config.body)
            }
            
            context.commit('set_is_submitting', true)
            return globalFetch(url, init)
            .then((response) => {
                if (!response.ok) {
                    return Promise.reject(response.error)
                }
                return response.json()
            })
            .catch((err) => {
                console.error(err)
                context.commit('set_is_submitting', false)
            })
        },
        trackPurchaseData(context, payload) {
            
            const gtmActive = !!window?.dataLayer?.find(
                (element) => element['gtm.start']
            ) // check if gtm is active
            
            if (!gtmActive) return
            
            let url = `${document.location.origin}/${process.env.GET_PURCHASE_DATA}?orderId=${payload.orderId}`

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = { headers, method: 'GET' }

            globalFetch(url, init)
                .then((response) => {
                    if (!response.ok) {
                        return Promise.reject(response.error);
                    }
                    if (response.status === 204) {
                        return Promise.reject("purchase tracking data not available.");
                    }
                    return response.json()
                })
                .then((json) => {
                    window.dataLayer = window.dataLayer || []
                    dataLayer.push({ ecommerce: null })
                    var purchaseEvent = {
                        event: 'purchase',
                        ecommerce: json
                    }
                    dataLayer.push(purchaseEvent)
                })
                .catch((err) =>
                    console.error(
                        'Kvittering: Der skete en fejl. Årsag: ',
                        err
                    )
                )
        }
    }
}
